module.exports = __webpack_public_path__ + "static/00023.dd79c8b0.jpg";